import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/roth-vs-traditional',
  component: () => import('../../routes/RothTraditional.svelte'),
  card: {
    id: 'roth-vs-traditional',
    title: 'Roth vs Traditional',
    description: 'Compare Roth and Traditional retirement contributions to see which strategy builds more after-tax wealth based on your tax rates, returns, and employer match.',
    icon: 'swap_horiz',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/roth-vs-traditional',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Roth vs Traditional Calculator – Compare Retirement Contribution Strategies',
    description: 'Free Roth vs Traditional calculator to compare after-tax retirement wealth from Roth and Traditional 401k and IRA contributions. See which strategy wins based on your tax rates, returns, employer match, and investment growth.',
  },
};

export default meta;
